import { MouseEvent, useCallback, useState } from 'react';

export const useOpenMenu = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const openMenu = useCallback(() => setMenuOpen(true), []);
  const closeMenu = useCallback(() => setMenuOpen(false), []);

  // Use for onContextMenu: without preventDefault the browser's own menu opens on top of ours.
  const openContextMenu = useCallback((e: MouseEvent) => {
    e.preventDefault();
    setMenuOpen(true);
  }, []);

  return {
    menuOpen,
    openMenu,
    openContextMenu,
    closeMenu,
  };
};
